<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">제품사양관리</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelUpload">엑셀가져오기</el-button>
          </el-form-item>
        </div>
      </el-form>
    <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="4">
              <el-form-item label="제조사">
                <el-select v-model="form.maker">
                  <el-option value=''  label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['Maker']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="제품군">
                <el-select v-model="form.modelGroup" style="width: 30%;">
                  <el-option value='' label="선택">선택</el-option>
                  <el-option
                      v-for="item in combos['ModelGroup']"
                      :key="item.id"
                      :value="item"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.modelCd" style="width: 40%;" v-if="form.modelGroup != '' && combos['ModelDetail']">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['ModelDetail']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="대표모델">
                <el-input type="text" v-model="form.standardModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="모델명">
                <el-input type="text" v-model="form.modelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain">
        <div class="table-sub-contain"  style="width: 100%;">
          <div class="table-area">
            <div class="table-b">
              <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
              <ag-grid-vue
                  ref="gridSub"
                  style="width: 100%; height: 78vh; min-height: 25px;"
                  class="ag-theme-alpine"
                  rowSelection="multiple"
                  :columnDefs="columnDefsSub"
                  :defaultColDef="defaultColDefSub"
                  :frameworkComponents="frameworkComponents"
                  :rowData="subData"
                  :gridOptions="gridOptionsSub"
                  :suppressRowClickSelection="false"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
// import ProductMenu from '@/components/LucomsModal/ModelSpec.vue';
import ProductMenu from '@/components/InfoManage/ProductMng/ProductMenu.vue';
import ProductUploadExcel from "@/components/InfoManage/ProductMng/ProductUploadExcel";

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "product",
  components: {},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      form: {
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        modelDetail : "",
        standardModelNm : "",
        modelNm : "",
      },
      defForm: {
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
      },
      data: [],
      subData: [],
      titleData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      makerCombo : [],
      productCombo1 : [],
      productCombo2 : [],
      componentForm : [],
      combos: {
        'Maker': [], //제조사
        'ModelGroup': [], //제품군
        'ModelDetail': [], //제품군 select,
      },
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();

      this.init();

    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indigroupe if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };
    },
    //Main 그리드 SelctionChange 발생
    onSelectionChangedMain(event) {
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.groupDetail = this.defForm;
      this.parentNm = voRow[0].menu_nm;
      this.$store.commit('loading')
      this.$http
          .post("/api/group/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow[0].menu_id,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow[0].menu_id;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClicked(event) {
      const idx = event.rowIndex
      const rowData = this.$refs.gridSub.rowData;

      this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {titleData : this.titleData ,data: event.data}});

      // this.$http
      //     .post("/api/productMng/detail", {
      //       companyId: this.$store.state.loginInfo.compCd,
      //       modelGroup: rowData[idx].modelGroup,
      //       modelCd : rowData[idx].modelCd,
      //       processTime : ""
      //     })
      //     .then(response => {
      //       this.$modal.open({component: ProductMenu, parent: this, width: 1200, props: {titleData : this.titleData ,data: event.data}});
      //     }).finally(() => {
      //   this.$store.commit('finish')
      // });

    },
    goOpen() {

      if(this.form.modelGroup == ''){
        this.$swal({ type: 'error', text: '제품군을 선택하여 주세요.' });
        return;
      }
      // else if(this.form.modelGroup.value !== '' && this.combos['ModelDetail'].length > 0 && this.form.modelCd == ''){
      //   this.$swal({ type: 'error', text: '제품 상세분류를 선택해 주세요.' });
      //   return;
      // }


      this.$store.commit('loading');
      this.$http
          .post("/api/productMng/title/list", {
            companyId: this.$store.state.loginInfo.compCd,
            modelGroup : this.GroupCheck(this.form.modelCd),
            processTime : ""
          })
          .then(response => {
            this.columnDefsSub = [];
            this.titleData = response.data[0];
            if(this.titleData){ // 헤더 결과 값이 있어야 조회 가능
              this.makeColumnList(this.titleData);
              this.$http
                  .post("/api/productMng/list", {
                    companyId: this.$store.state.loginInfo.compCd,
                    modelCd : this.form.modelNm,
                    maker : this.form.maker,
                    modelGroup : this.GroupCheck(this.form.modelCd),
                    standardModelNm : this.form.standardModelNm,
                    sortType : true,
                    page : 1,
                    totalPage : 9999,
                    totalCount : 9999,
                    curPage : 0,
                    processTime : ""
                  })
                  .then(response => {
                    this.subData = response.data
                  }).finally(() => {
                this.autoSizeAll(this.columnApi);
              });
            }

          }).finally(() => {
        this.$store.commit('finish')
      });


    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    makeColumnList(titleData){
      for(var i = 1; 50 >= i ; i++){ // 컬럼 갯수
        let hName = eval("titleData.modelSpec"+this.StringFormat(i));
        let fName = "modelSpec"+this.StringFormat(i);
        if(hName !== "")
          this.columnDefsSub.push({
            headerName: hName,
            field: fName,
            width: 100,
            editable: false
          });
      }
    },
    excelUpload(){

      if(this.form.modelGroup == ''){
        this.$swal({ type: 'error', text: '제품군을 선택하여 주세요.' });
        return;
      }
      // else if(this.form.modelGroup.value !== '' && this.combos['ModelDetail'].length > 0 && this.form.modelCd == ''){
      //   this.$swal({ type: 'error', text: '제품 상세분류를 선택해 주세요.' });
      //   return;
      // }


      this.$store.commit('loading');
      this.$http
          .post("/api/productMng/title/list", {
            companyId: this.$store.state.loginInfo.compCd,
            modelGroup : this.GroupCheck(this.form.modelCd),
            processTime : ""
          })
          .then(response => {
            this.titleData = response.data[0];

            /** 엑셀업로드 */
            let vm = this;
            this.$modal.open({
              width: 800,
              component: ProductUploadExcel,
              parent: this,
              props: {
                titleData : this.titleData,
                groupNm : this.GroupNmCheck(this.form.modelCd)
              },
              events: {
                close(param) {
                  vm.goOpen();
                },
              }
            });

          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    StringFormat(num){
        if(num < 10){
          num = "0"+num
        }
        return num;
    },
    GroupCheck(modelCd) {
      let val = "";
      if(modelCd == undefined || modelCd == null || modelCd == ""){
        if(this.form.modelGroup.key != undefined){
          val = this.form.modelGroup.key;
        }
      }else{
        if(this.form.modelCd != undefined){
          val = this.form.modelCd;
        }
      }
      return val
    },
    GroupNmCheck(modelCd) {
      let val = "";
      if(modelCd == undefined || modelCd == null || modelCd == ""){
        if(this.form.modelGroup.key != undefined){
          val = this.form.modelGroup.value;
        }
      }else{
        if(this.form.modelCd != undefined){
          this.combos['ModelDetail'].forEach(x=>{
            if(x.key == this.form.modelCd) val = x.value;
          });
        }
      }
      return val
    },
    saveIdx() {

      let subData = this.$refs.gridSub.rowData;
      try {
        for(var i=0; subData.length; i++){
          this.$http
              .put('/api/group/update/idx',{
                companyId: this.$store.state.loginInfo.compCd,
                groupId: subData[i].groupId,
                groupIdx: subData[i].groupIdx,
                updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
                processTime: ""
              })
              .then(response => {

              })
              .catch(({ message }) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({ type: "error", text: "오류가 발생했습니다." });
                }
              });
        }
      }catch (e){
        this.$swal({
          type: 'error',
          text: '오류가 발생했습니다.'
        })
      }
      this.$swal({ type: 'success', text: '수정되었습니다.' });
      this.goOpen();

    },

    deleteRow() {

      const grid = this.$refs.gridSub

      const chkDatas = grid.rowData.filter((x,i) => {
        return x.regYn === "1"
      })

      if(chkDatas.length == 0)this.$swal({ type: 'error', text: '삭제할 분류를 체크하세요.' });

      for (var i = 0; chkDatas.length > i ; i++){
        let groupUid = parseInt(chkDatas[i].groupUid);
        let updatorId = this.$store.state.loginInfo.compCd.loginId; // 추후 로그인 id 받아서 처리
        let compCd =  this.$store.state.loginInfo.compCd;
        this.$http.delete(_url("/api/group/delete/"+ (compCd) +"/"+ (groupUid) + "/" + (updatorId) ), {
          process_time : new Date()
        }).then(response => {
          this.$swal({ type: 'success', text: '삭제 되었습니다.' });
          this.goOpen();
        });
      }


    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.gridApiSub.getSelectedNodes()

        if(row.length < 1)
          throw '선택된 행이 없습니다.'

        let index = row[0].rowIndex
        this.subData.splice(index, 1)

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try{

        const row = this.gridApi.getSelectedNodes()

        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex

        this.subData.push({
          detailCd: "",
          detailNm: "",
          useYn: "Y",
          orderSeq: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          detailDesc: "",
          parent_id: this.data[0].inner_menu[idx-1].parent_id,
          compCd: this.$store.state.loginInfo.compCd,
        });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    async init() {
      this.$store.commit('loading');
      let [query, form] = await Promise.all([
        this.$http.post(`/api/productMng/service/init`,{
          parentId: this.form.modelGroup.id
        })
      ]).finally(() => {
        this.form.modelCd = "";
        this.$store.commit('finish');
      });

      this.combos['Maker'] = query.data.maker;
      this.combos['ModelGroup'] = query.data.modelGroup;
      this.combos['ModelDetail'] = query.data.modelDetail;
      // this.form = form.data;
    },
    cancel(){
      // groupInfo 초기화
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    // this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch:{
    'form.modelGroup'(){
      this.init();
    }
  }
};

</script>


<style scoped>
.gridbox {
  height: 200px !important;
}
.gridbox .objbox {
  height: 350px !important;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}
.btn-wrap {
  margin-bottom: 20px;
}
.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}
.desc-content .item {
  float: left;
}
.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}
.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}
.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}
.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}
.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}
.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}
.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-right {
  width: 30%;
}
.search-area input {
  position: relative;
}
.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}
.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}
.search-border .td-s-thumb.search-area > input,
.search-border
.td-s-thumb.search-area
> .ip-box
.search-border
.td-s-thumb.search-area
> button {
  float: left;
}
.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}
.remove_text {
  margin-left: 0;
}
.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

.btn-search {
  border-radius: 4px;
  padding: 0 20px;
  font-size: 15px;
  height: 34px;
  font-family: 'NotoM';
  background: #646464;
  color: #fff;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}
</style>